import baseElement from '@/mixins/base-element/base-element-dumb';

export default {
    mixins: [baseElement],

    props: {
        // rendering uid from Sitecore layout
        renderingId: {
            type: String,
            default: '',
        },

        renderingName: {
            type: String,
            default: '',
        },

        // whether the rendering is on final layout details or shared details (template)
        renderingField: {
            type: String,
            default: '',
        },

        // GUID of datasource item in Sitecore
        dataSourceId: {
            type: String,
            default: '',
        },

        // all child elements, 1 to 1 child items in Sitecore
        elements: {
            type: Array,
            default: () => ([]),
        },
    },

    data() {
        return {
            elementsNew: this.elements,
        };
    },

    created() {
        this.templateType = 'Organism';
    },

    methods: {
        element(pointer) {
            return this.elements.find(e => pointer === e.pointer);
        },

        elementUpdated() {
            // noop
        },
    },
};
